type AccessTokenProvider = () => Promise<string>

/**
 * The single place sagas ask for an access token. AuthKit holds the token in React context, so
 * `WorkosAuthBridge` registers its `getAccessToken` here on sign-in and clears it on sign-out —
 * nothing is persisted by this app, and there is no token to read before a session exists.
 */
class AuthService {
  private accessTokenProvider: AccessTokenProvider | null = null

  public setAccessTokenProvider(provider: AccessTokenProvider | null) {
    this.accessTokenProvider = provider
  }

  public hasSession(): boolean {
    return this.accessTokenProvider !== null
  }

  public async getAccessToken(): Promise<string | null> {
    if (!this.accessTokenProvider) {
      return null
    }

    return this.accessTokenProvider()
  }
}

export const authService = new AuthService()
